import { IinputValue } from "../Components/Pumkin/RegiterWarranty";
import axiosClient from "./axiosClient";

export const pumkinAPI = {
    getDeviceList: (params: string) => {
        const url = "assets/pumpkin";
        return axiosClient.get(url + params);
    },
    getChannelList: () => {
        const url = "channel";
        return axiosClient.get(url);
    },
    getStoreList: (params: string) => {
        const url = "channel/";
        return axiosClient.get(url + params);
    },
    getPumpkinStoreList: (params: { name: string }) => {
        const url = "assets/pumpkin/store";
        return axiosClient.get(url, { params });
    },
    registerWarranty: (values: IinputValue) => {
        const url = "assets/pumpkin/warranty/create";
        return axiosClient.post(url, values);
    },
    getWarrantyList: (params: any) => {
        const url = "assets/pumpkin/warranty";
        return axiosClient.get(url, { params });
    },
    verifyProduct: (params: string) => {
        const url = "assets/pumpkin/verify";
        return axiosClient.get(url + params);
    },
    searchMyDevice: (params: string) => {
        const url = "assets/pumpkin/search";
        return axiosClient.get(url + params);
    },
    getPumpkinChannel: () => {
        const url = "assets/pumpkin/channel";
        return axiosClient.get(url);
    },
};
